import { GlobalErrorHandlerService } from './global-error-handler.service';

// AuthService and UserService are root-scoped. Re-providing them from the
// lazy AuthModule creates duplicate session state, event subscriptions and
// idle/logout handlers.
export const services = [GlobalErrorHandlerService];

export * from './auth.service';
export * from './user.service';
export * from './auth-context'
export * from './global-error-handler.service';
